
const PonudjeniOdgovorKorisnik = ({ odgovor, tip, onOdgovorChange }) => {

    const handleChange = (e) => {
    const { checked, value } = e.target;

    onOdgovorChange({
      pitanjeId: odgovor.pitanjeId,
      tekstOdgovora: value,
      checked: checked,
    });
  };
 

  return (
    <div className="ponudjeni-odgovor-item">
      {tip === "VISESTRUKI_IZBOR" ? (
        <label className="ponudjeni-odgovor-label">
          <input type="checkbox" name={`odgovor-${odgovor.pitanjeId}`} value={odgovor.tekstOdgovora} onChange={handleChange} className="ponudjeni-odgovor-input" />
          {odgovor.tekstOdgovora}
        </label>
      ) : (
        <label className="ponudjeni-odgovor-label">
          <input type="radio" name={`odgovor-${odgovor.pitanjeId}`} value={odgovor.tekstOdgovora} onChange={handleChange} className="ponudjeni-odgovor-input"/>
          {odgovor.tekstOdgovora}
        </label>
      )}
    </div>
  );
};

export default PonudjeniOdgovorKorisnik;